(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[832],{

/***/ 36994:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/[type]/[slug]",
      function () {
        return __webpack_require__(68239);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 99303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FaqsList": function() { return /* binding */ FaqsList; },
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _app_hocs_PageLayoutV1__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75019);
/* harmony import */ var _app_utilities_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46613);
/* harmony import */ var _components_hocs_SimpleCollapsibleHoc__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6881);







var __N_SSG = true;
var FaqsList = function(param) {
    var faqs = param.ssrFaqs;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(faqs.map(function() {
        return false;
    })), expandedCollapsibles = ref[0], setExpandedCollapsibles = ref[1];
    var onCollapsibleToggled = function(id, isExpanded) {
        if (isExpanded) {
            var tmpExpandedCollapsibles = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(expandedCollapsibles), idx = parseInt(id);
            for(var i = 0, len = tmpExpandedCollapsibles.length; i < len; i++){
                if (i !== idx && tmpExpandedCollapsibles[i] === true) {
                    tmpExpandedCollapsibles[i] = false;
                } else if (i === idx) {
                    tmpExpandedCollapsibles[i] = true;
                }
            }
            setExpandedCollapsibles(tmpExpandedCollapsibles);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect)(function() {
        if (true) {
            var faqSlugHash = (window.location.hash || "").slice(1);
            if (faqSlugHash) {
                var idx = faqs.findIndex(function(qna) {
                    return qna.slug === faqSlugHash;
                });
                if (idx !== -1) {
                    var tmpExpandedCollapsibles = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(expandedCollapsibles);
                    tmpExpandedCollapsibles[idx] = true;
                    setExpandedCollapsibles(tmpExpandedCollapsibles);
                }
            }
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "faqs-wrapper",
        itemScope: true,
        itemType: "https://schema.org/FAQPage",
        children: faqs.length ? faqs.map(function(qna, idx) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "faq",
                itemScope: true,
                itemProp: "mainEntity",
                itemType: "https://schema.org/Question",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        itemProp: "name",
                        content: qna.question
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_hocs_SimpleCollapsibleHoc__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        open: expandedCollapsibles[idx],
                        id: idx.toString(),
                        title: qna.question,
                        onToggled: onCollapsibleToggled,
                        collapsibleProps: {
                            itemScope: true,
                            itemProp: "acceptedAnswer",
                            itemType: "https://schema.org/Answer"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "answer",
                            itemProp: "text",
                            dangerouslySetInnerHTML: {
                                __html: qna.answer.html
                            }
                        })
                    })
                ]
            }, idx);
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            className: "text-center",
            children: "No FAQs found"
        })
    });
};
var FaqsPage = function(param) {
    var ssrFaqs = param.ssrFaqs;
    var faqs = ssrFaqs;
    /**
   * Meta contents
   */ var metaTitle = "FAQ | Heritage Counseling", metaDescription = _app_utilities_constants__WEBPACK_IMPORTED_MODULE_4__/* .META_DESCRIPTION */ .KM || "", metaUrl = "".concat(_app_utilities_constants__WEBPACK_IMPORTED_MODULE_4__/* .META_URL */ .f1, "/faqs"), metaImage = "".concat(_app_utilities_constants__WEBPACK_IMPORTED_MODULE_4__/* .META_URL */ .f1, "/logo.png");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_app_hocs_PageLayoutV1__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        title: "Frequently Asked Question",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: metaTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "title",
                        content: metaTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: metaDescription
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: metaTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: metaDescription
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: metaUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: metaImage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:url",
                        content: metaUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: metaTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: metaDescription
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: metaImage
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        itemProp: "title",
                        content: metaTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        itemProp: "description",
                        content: metaDescription
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: metaUrl
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "faqs-page",
                "data-testid": "faqs-page",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FaqsList, {
                    ssrFaqs: faqs
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FaqsPage);


/***/ }),

/***/ 68239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/app/hocs/PageLayoutV1.tsx + 1 modules
var PageLayoutV1 = __webpack_require__(75019);
// EXTERNAL MODULE: ./src/app/utilities/helpers.ts
var helpers = __webpack_require__(3862);
// EXTERNAL MODULE: ./src/app/utilities/constants.ts
var constants = __webpack_require__(46613);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/app/components/hocs/HorizontalLayoutView/horizontal-layout-view.module.scss
var horizontal_layout_view_module = __webpack_require__(63413);
var horizontal_layout_view_module_default = /*#__PURE__*/__webpack_require__.n(horizontal_layout_view_module);
// EXTERNAL MODULE: ./src/app/components/common/SafeImage.tsx
var SafeImage = __webpack_require__(22320);
;// CONCATENATED MODULE: ./src/app/components/hocs/HorizontalLayoutView/HorizontalLayoutViewComp.tsx





var HorizontalLayoutViewComp = function(props) {
    var header = props.header, imageProps = props.imageProps, children = props.children, className = props.className, classes = classnames_default()((horizontal_layout_view_module_default())["horizontal-layout-view"], className, "clearfix");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((horizontal_layout_view_module_default())["img-container"], (horizontal_layout_view_module_default()).float, (horizontal_layout_view_module_default())["desk-only"]),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeImage/* default */.Z, {
                    src: imageProps.src,
                    alt: imageProps.alt,
                    width: imageProps.width,
                    height: imageProps.height
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((horizontal_layout_view_module_default()).content),
                children: [
                    header,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()((horizontal_layout_view_module_default())["img-container"], (horizontal_layout_view_module_default())["mobile-only"]),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SafeImage/* default */.Z, {
                            src: imageProps.src,
                            alt: imageProps.alt,
                            width: imageProps.width,
                            height: imageProps.height
                        })
                    }),
                    children
                ]
            })
        ]
    });
};
/* harmony default export */ var HorizontalLayoutView_HorizontalLayoutViewComp = (HorizontalLayoutViewComp);

// EXTERNAL MODULE: ./pages/faqs.tsx
var pages_faqs = __webpack_require__(99303);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/styles/components/common/cms_abstract.module.scss
var cms_abstract_module = __webpack_require__(96104);
var cms_abstract_module_default = /*#__PURE__*/__webpack_require__.n(cms_abstract_module);
// EXTERNAL MODULE: ./node_modules/react-markdown/lib/react-markdown.js + 126 modules
var react_markdown = __webpack_require__(66278);
;// CONCATENATED MODULE: ./src/app/components/common/CmsAbstract.tsx







var CmsAbstract = function(props) {
    var data = props.data, className = props.className, classes = classnames_default()((cms_abstract_module_default())["cms-abstract"], className);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
            remarkPlugins: [],
            components: {
                a: function(_param) /*#__PURE__*/ {
                    var node = _param.node, _$props = (0,_object_without_properties/* default */.Z)(_param, [
                        "node"
                    ]);
                    return (0,jsx_runtime.jsx)("a", (0,_object_spread/* default */.Z)({
                        target: "_blank",
                        rel: "noopener noreferrer"
                    }, _$props));
                }
            },
            children: data
        })
    });
};
/* harmony default export */ var common_CmsAbstract = (CmsAbstract);

// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 34 modules
var format = __webpack_require__(72167);
// EXTERNAL MODULE: ./src/app/hooks/WithUpdateCmsVisit.tsx
var WithUpdateCmsVisit = __webpack_require__(13325);
// EXTERNAL MODULE: ./pages/[...paths].tsx + 7 modules
var _paths_ = __webpack_require__(35916);
;// CONCATENATED MODULE: ./pages/services/[type]/[slug].tsx













var ServiceDetailPage = function(props) {
    var ref;
    if (props.customUri) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(_paths_["default"], {
            uri: props.uri,
            customUri: props.customUri
        });
    }
    var service = props.service, title = [
        service.type,
        "Services"
    ].join(" "), serviceMetaDescription = (0,helpers/* sliceMetaDescription */.rJ)(service.content.text), faqs = (service === null || service === void 0 ? void 0 : service.faqs) || [], blogs = (service === null || service === void 0 ? void 0 : service.blogs) || [], showPhone = [
        "marriage-retreat",
        "neurofeedback"
    ].indexOf(service.slug) >= 0;
    /**
   * Meta contents
   */ var metaTitle = constants/* META_TITLE */.k5 || "", metaDescription = constants/* META_DESCRIPTION */.KM || "", metaUrl = constants/* META_URL */.f1 || "", metaOgImg = constants/* META_URL */.f1 + "/logo.png", metaTwitterImg = constants/* META_URL */.f1 + "/logo.png";
    if (service) {
        var ref1, ref2;
        metaTitle = "".concat(service.name, " | Heritage Counseling");
        metaDescription = serviceMetaDescription || metaDescription;
        metaUrl = "".concat(constants/* META_URL */.f1, "/services/").concat(service.typeSlug, "/").concat(service.slug);
        metaOgImg = ((ref1 = service.image) === null || ref1 === void 0 ? void 0 : ref1.url) || metaOgImg;
        metaTwitterImg = ((ref2 = service.image) === null || ref2 === void 0 ? void 0 : ref2.url) || metaTwitterImg;
    }
    // Override metas using pageMeta
    var pageMeta = (service === null || service === void 0 ? void 0 : service.meta) || {};
    if (Object.keys(pageMeta).length > 0) {
        var ref3, ref4;
        metaTitle = (pageMeta === null || pageMeta === void 0 ? void 0 : pageMeta.title) || metaTitle;
        metaDescription = (pageMeta === null || pageMeta === void 0 ? void 0 : pageMeta.description) || metaDescription;
        metaOgImg = (pageMeta === null || pageMeta === void 0 ? void 0 : (ref3 = pageMeta.ogImage) === null || ref3 === void 0 ? void 0 : ref3.url) || metaOgImg;
        metaTwitterImg = (pageMeta === null || pageMeta === void 0 ? void 0 : (ref4 = pageMeta.twitterImage) === null || ref4 === void 0 ? void 0 : ref4.url) || metaTwitterImg;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageLayoutV1/* default */.Z, {
        title: title,
        fluidContainer: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: metaTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "title",
                        content: metaTitle
                    }, "title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: metaDescription
                    }, "description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: metaTitle
                    }, "og:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: metaDescription
                    }, "og:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: metaUrl
                    }, "og:url"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: metaOgImg
                    }, "og:image"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:url",
                        content: metaUrl
                    }, "twitter:url"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: metaTitle
                    }, "twitter:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: metaDescription
                    }, "twitter:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: metaTwitterImg
                    }, "twitter:image"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        itemProp: "title",
                        content: metaTitle
                    }, "prop:title"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        itemProp: "description",
                        content: metaDescription
                    }, "prop:description"),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: metaUrl
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "service-detail-page",
                "data-testid": "service-detail-page",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                            className: "mb-5 mb-lg-10",
                            role: "navigation",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/services",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "link-back",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fa fa-angle-left"
                                        }),
                                        "Back to Services"
                                    ]
                                })
                            })
                        })
                    }),
                    !!(service === null || service === void 0 ? void 0 : (ref = service.secondaryContent) === null || ref === void 0 ? void 0 : ref.html) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "service-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cms-content",
                                dangerouslySetInnerHTML: {
                                    __html: service.secondaryContent.html
                                }
                            })
                        })
                    }),
                    service ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "service-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HorizontalLayoutView_HorizontalLayoutViewComp, {
                                imageProps: {
                                    src: service.image.src,
                                    alt: service.name,
                                    width: service.image.width,
                                    height: service.image.height
                                },
                                header: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "header",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "title",
                                        children: service.name || ""
                                    })
                                }),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cms-content",
                                        dangerouslySetInnerHTML: {
                                            __html: service.content.html
                                        }
                                    }),
                                    showPhone && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        title: "Phone",
                                        "aria-label": "Phone",
                                        href: "tel:".concat(constants/* COMPANY_PHONE_NUMBER */.x),
                                        className: "btn btn-external btn-main px-5 py-3 mt-5",
                                        rel: "noopener noreferrer",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: "Call for more information"
                                        })
                                    })
                                ]
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-center",
                        children: "No service found"
                    }),
                    !!service.abstract && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "rel-section abstract-section",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_CmsAbstract, {
                                className: "abstract-wrapper",
                                data: service.abstract
                            })
                        })
                    }),
                    !!(faqs === null || faqs === void 0 ? void 0 : faqs.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "rel-section service-faqs-section",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                    className: "rel-title",
                                    children: [
                                        "FAQ About ",
                                        service.name,
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(pages_faqs.FaqsList, {
                                    ssrFaqs: faqs
                                })
                            ]
                        })
                    }),
                    !!(blogs === null || blogs === void 0 ? void 0 : blogs.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                        className: "rel-section service-blogs-section",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "container",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "rel-title",
                                    children: "Related Blogs"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "blogs-list",
                                    children: blogs.map(function(blog, idx) {
                                        var ref;
                                        var bodyText = (0,helpers/* sliceMetaDescription */.rJ)(blog.content.text, 210), publishedDateStr = (0,format/* default */.Z)(blog.createdAt, "PP");
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/blogs/".concat(blog.slug),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "card blog-card",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "row",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "col-md-4 col-xl-3 img-container",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                className: "img-blog",
                                                                src: ((ref = blog.featuredImage) === null || ref === void 0 ? void 0 : ref.src) || "",
                                                                alt: blog.title,
                                                                height: 150,
                                                                width: 150
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "col-md-8 col-xl-9",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "card-body",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                        className: "card-title",
                                                                        children: blog.title
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "card-text",
                                                                        children: bodyText
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                        className: "card-text",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                                                            className: "text-muted",
                                                                            children: [
                                                                                "Published on ",
                                                                                publishedDateStr
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        }, idx);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                            className: "mt-5 mt-lg-10",
                            role: "navigation",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/services",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    className: "link-back",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fa fa-angle-left"
                                        }),
                                        "Back to Services"
                                    ]
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var _slug_ = ((0,WithUpdateCmsVisit/* withUpdateCmsVisit */.D)(ServiceDetailPage));


/***/ }),

/***/ 6881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9966);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _app_utilities_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3862);







var SimpleCollapsibleHoc = function(param) {
    var id = param.id, title = param.title, children = param.children, open = param.open, className = param.className, onToggled = param.onToggled, collapsibleProps = param.collapsibleProps;
    var classes = classnames__WEBPACK_IMPORTED_MODULE_2___default()("simple-collapsible-hoc", className), ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(!!open), expanded = ref[0], setExpanded = ref[1], onTitleClick = function(evt) {
        evt.preventDefault();
        setExpanded(!expanded);
        if (onToggled && typeof onToggled === "function") {
            onToggled(id, !expanded);
        }
        return false;
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!(0,_app_utilities_helpers__WEBPACK_IMPORTED_MODULE_3__/* .isNullOrUndefined */ .le)(open)) {
            setExpanded(open);
            return;
        }
    }, [
        open
    ]);
    if (!collapsibleProps) {
        collapsibleProps = {};
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classes,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                className: "collapsible-link link",
                "aria-label": title,
                onClick: onTitleClick,
                children: [
                    title,
                    "\xa0",
                    expanded ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "fa fa-angle-up"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "fa fa-angle-down"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                timeout: 0,
                in: expanded,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                    className: "collapsible-container"
                }, collapsibleProps), {
                    children: children
                }))
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SimpleCollapsibleHoc);


/***/ }),

/***/ 13325:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ withUpdateCmsVisit; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _app_utilities_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46613);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50196);









var withUpdateCmsVisit = function(PageComponent) {
    var WithUpdateCmsVisit = function(_param) {
        var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, _param);
        var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)(), pageUri = router.asPath.replace(/\?.*$/i, "");
        (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
            // Increment visits
            if (typeof navigator !== "undefined" && _app_utilities_constants__WEBPACK_IMPORTED_MODULE_2__/* .IS_PROD */ .XK) {
                var data = {
                    uri: pageUri
                };
                axios__WEBPACK_IMPORTED_MODULE_4__/* ["default"].get */ .Z.get("/api/analytics", {
                    params: data
                });
            }
        }, []);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PageComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props));
    };
    if (PageComponent.getInitialProps) {
        WithUpdateCmsVisit.getInitialProps = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(appCtx) {
                var pageProps;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                PageComponent.getInitialProps ? PageComponent.getInitialProps(appCtx) : {}
                            ];
                        case 1:
                            pageProps = _state.sent();
                            return [
                                2,
                                (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, pageProps)
                            ];
                    }
                });
            });
            return function(appCtx) {
                return _ref.apply(this, arguments);
            };
        }();
    }
    return WithUpdateCmsVisit;
};


/***/ }),

/***/ 63413:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Lf","container-fluid":"Lh","row":"Lj","col-xl-9":"Ll","col-xl-3":"Ln","col-md-8":"Lp","col-md-4":"Lr","col-sm-4":"Lt","col-12":"Lv","d-none":"Lx","d-block":"Lz","d-table":"Lab","d-table-row":"Lad","d-table-cell":"Laf","d-flex":"Lah","d-sm-table":"Laj","d-sm-table-row":"Lal","d-sm-table-cell":"Lan","d-md-inline":"Lap","d-md-table":"Lar","d-md-table-row":"Lat","d-md-table-cell":"Lav","d-lg-block":"Lax","d-lg-table":"Laz","d-lg-table-row":"La1","d-lg-table-cell":"La3","d-lg-flex":"La5","d-xl-inline":"La7","d-xl-table":"La9","d-xl-table-row":"La-","d-xl-table-cell":"Lbb","d-print-table":"Lbd","d-print-table-row":"Lbf","d-print-table-cell":"Lbh","flex-column":"Lbj","mt-0":"Lbl","my-0":"Lbn","mr-0":"Lbp","mx-0":"Lbr","mb-0":"Lbt","ml-0":"Lbv","mt-1":"Lbx","my-1":"Lbz","mr-1":"Lb1","mx-1":"Lb3","mb-1":"Lb5","ml-1":"Lb7","mt-2":"Lb9","my-2":"Lb-","mr-2":"Lcb","mx-2":"Lcd","mb-2":"Lcf","ml-2":"Lch","mt-3":"Lcj","my-3":"Lcl","mr-3":"Lcn","mx-3":"Lcp","mb-3":"Lcr","ml-3":"Lct","mt-4":"Lcv","my-4":"Lcx","mr-4":"Lcz","mx-4":"Lc1","mb-4":"Lc3","ml-4":"Lc5","mt-5":"Lc7","my-5":"Lc9","mr-5":"Lc-","mx-5":"Ldb","mb-5":"Ldd","ml-5":"Ldf","p-0":"Ldh","pt-0":"Ldj","py-0":"Ldl","pr-0":"Ldn","px-0":"Ldp","pb-0":"Ldr","pl-0":"Ldt","pt-1":"Ldv","py-1":"Ldx","pr-1":"Ldz","px-1":"Ld1","pb-1":"Ld3","pl-1":"Ld5","pt-2":"Ld7","py-2":"Ld9","pr-2":"Ld-","px-2":"Leb","pb-2":"Led","pl-2":"Lef","p-3":"Leh","pt-3":"Lej","py-3":"Lel","pr-3":"Len","px-3":"Lep","pb-3":"Ler","pl-3":"Let","pt-4":"Lev","py-4":"Lex","pr-4":"Lez","px-4":"Le1","pb-4":"Le3","pl-4":"Le5","pt-5":"Le7","py-5":"Le9","pr-5":"Le-","px-5":"Lfb","pb-5":"Lfd","pl-5":"Lff","mt-n1":"Lfh","my-n1":"Lfj","mr-n1":"Lfl","mx-n1":"Lfn","mb-n1":"Lfp","ml-n1":"Lfr","mt-n2":"Lft","my-n2":"Lfv","mr-n2":"Lfx","mx-n2":"Lfz","mb-n2":"Lf1","ml-n2":"Lf3","mt-n3":"Lf5","my-n3":"Lf7","mr-n3":"Lf9","mx-n3":"Lf-","mb-n3":"Lgb","ml-n3":"Lgd","mt-n4":"Lgf","my-n4":"Lgh","mr-n4":"Lgj","mx-n4":"Lgl","mb-n4":"Lgn","ml-n4":"Lgp","mt-n5":"Lgr","my-n5":"Lgt","mr-n5":"Lgv","mx-n5":"Lgx","mb-n5":"Lgz","ml-n5":"Lg1","ml-auto":"Lg3","mt-sm-0":"Lg5","my-sm-0":"Lg7","mr-sm-0":"Lg9","mx-sm-0":"Lg-","mb-sm-0":"Lhb","ml-sm-0":"Lhd","mt-sm-1":"Lhf","my-sm-1":"Lhh","mr-sm-1":"Lhj","mx-sm-1":"Lhl","mb-sm-1":"Lhn","ml-sm-1":"Lhp","mt-sm-2":"Lhr","my-sm-2":"Lht","mr-sm-2":"Lhv","mx-sm-2":"Lhx","mb-sm-2":"Lhz","ml-sm-2":"Lh1","mt-sm-3":"Lh3","my-sm-3":"Lh5","mr-sm-3":"Lh7","mx-sm-3":"Lh9","mb-sm-3":"Lh-","ml-sm-3":"Lib","mt-sm-4":"Lid","my-sm-4":"Lif","mr-sm-4":"Lih","mx-sm-4":"Lij","mb-sm-4":"Lil","ml-sm-4":"Lin","mt-sm-5":"Lip","my-sm-5":"Lir","mr-sm-5":"Lit","mx-sm-5":"Liv","mb-sm-5":"Lix","ml-sm-5":"Liz","pt-sm-0":"Li1","py-sm-0":"Li3","pr-sm-0":"Li5","px-sm-0":"Li7","pb-sm-0":"Li9","pl-sm-0":"Li-","pt-sm-1":"Ljb","py-sm-1":"Ljd","pr-sm-1":"Ljf","px-sm-1":"Ljh","pb-sm-1":"Ljj","pl-sm-1":"Ljl","pt-sm-2":"Ljn","py-sm-2":"Ljp","pr-sm-2":"Ljr","px-sm-2":"Ljt","pb-sm-2":"Ljv","pl-sm-2":"Ljx","pt-sm-3":"Ljz","py-sm-3":"Lj1","pr-sm-3":"Lj3","px-sm-3":"Lj5","pb-sm-3":"Lj7","pl-sm-3":"Lj9","pt-sm-4":"Lj-","py-sm-4":"Lkb","pr-sm-4":"Lkd","px-sm-4":"Lkf","pb-sm-4":"Lkh","pl-sm-4":"Lkj","pt-sm-5":"Lkl","py-sm-5":"Lkn","pr-sm-5":"Lkp","px-sm-5":"Lkr","pb-sm-5":"Lkt","pl-sm-5":"Lkv","mt-sm-n1":"Lkx","my-sm-n1":"Lkz","mr-sm-n1":"Lk1","mx-sm-n1":"Lk3","mb-sm-n1":"Lk5","ml-sm-n1":"Lk7","mt-sm-n2":"Lk9","my-sm-n2":"Lk-","mr-sm-n2":"Llb","mx-sm-n2":"Lld","mb-sm-n2":"Llf","ml-sm-n2":"Llh","mt-sm-n3":"Llj","my-sm-n3":"Lll","mr-sm-n3":"Lln","mx-sm-n3":"Llp","mb-sm-n3":"Llr","ml-sm-n3":"Llt","mt-sm-n4":"Llv","my-sm-n4":"Llx","mr-sm-n4":"Llz","mx-sm-n4":"Ll1","mb-sm-n4":"Ll3","ml-sm-n4":"Ll5","mt-sm-n5":"Ll7","my-sm-n5":"Ll9","mr-sm-n5":"Ll-","mx-sm-n5":"Lmb","mb-sm-n5":"Lmd","ml-sm-n5":"Lmf","mt-md-0":"Lmh","my-md-0":"Lmj","mr-md-0":"Lml","mx-md-0":"Lmn","mb-md-0":"Lmp","ml-md-0":"Lmr","mt-md-1":"Lmt","my-md-1":"Lmv","mr-md-1":"Lmx","mx-md-1":"Lmz","mb-md-1":"Lm1","ml-md-1":"Lm3","mt-md-2":"Lm5","my-md-2":"Lm7","mr-md-2":"Lm9","mx-md-2":"Lm-","mb-md-2":"Lnb","ml-md-2":"Lnd","mt-md-3":"Lnf","my-md-3":"Lnh","mr-md-3":"Lnj","mx-md-3":"Lnl","mb-md-3":"Lnn","ml-md-3":"Lnp","mt-md-4":"Lnr","my-md-4":"Lnt","mr-md-4":"Lnv","mx-md-4":"Lnx","mb-md-4":"Lnz","ml-md-4":"Ln1","mt-md-5":"Ln3","my-md-5":"Ln5","mr-md-5":"Ln7","mx-md-5":"Ln9","mb-md-5":"Ln-","ml-md-5":"Lob","pt-md-0":"Lod","py-md-0":"Lof","pr-md-0":"Loh","px-md-0":"Loj","pb-md-0":"Lol","pl-md-0":"Lon","pt-md-1":"Lop","py-md-1":"Lor","pr-md-1":"Lot","px-md-1":"Lov","pb-md-1":"Lox","pl-md-1":"Loz","pt-md-2":"Lo1","py-md-2":"Lo3","pr-md-2":"Lo5","px-md-2":"Lo7","pb-md-2":"Lo9","pl-md-2":"Lo-","pt-md-3":"Lpb","py-md-3":"Lpd","pr-md-3":"Lpf","px-md-3":"Lph","pb-md-3":"Lpj","pl-md-3":"Lpl","pt-md-4":"Lpn","py-md-4":"Lpp","pr-md-4":"Lpr","px-md-4":"Lpt","pb-md-4":"Lpv","pl-md-4":"Lpx","pt-md-5":"Lpz","py-md-5":"Lp1","pr-md-5":"Lp3","px-md-5":"Lp5","pb-md-5":"Lp7","pl-md-5":"Lp9","mt-md-n1":"Lp-","my-md-n1":"Lqb","mr-md-n1":"Lqd","mx-md-n1":"Lqf","mb-md-n1":"Lqh","ml-md-n1":"Lqj","mt-md-n2":"Lql","my-md-n2":"Lqn","mr-md-n2":"Lqp","mx-md-n2":"Lqr","mb-md-n2":"Lqt","ml-md-n2":"Lqv","mt-md-n3":"Lqx","my-md-n3":"Lqz","mr-md-n3":"Lq1","mx-md-n3":"Lq3","mb-md-n3":"Lq5","ml-md-n3":"Lq7","mt-md-n4":"Lq9","my-md-n4":"Lq-","mr-md-n4":"Lrb","mx-md-n4":"Lrd","mb-md-n4":"Lrf","ml-md-n4":"Lrh","mt-md-n5":"Lrj","my-md-n5":"Lrl","mr-md-n5":"Lrn","mx-md-n5":"Lrp","mb-md-n5":"Lrr","ml-md-n5":"Lrt","ml-md-auto":"Lrv","mt-lg-0":"Lrx","my-lg-0":"Lrz","mr-lg-0":"Lr1","mx-lg-0":"Lr3","mb-lg-0":"Lr5","ml-lg-0":"Lr7","mt-lg-1":"Lr9","my-lg-1":"Lr-","mr-lg-1":"Lsb","mx-lg-1":"Lsd","mb-lg-1":"Lsf","ml-lg-1":"Lsh","mt-lg-2":"Lsj","my-lg-2":"Lsl","mr-lg-2":"Lsn","mx-lg-2":"Lsp","mb-lg-2":"Lsr","ml-lg-2":"Lst","mt-lg-3":"Lsv","my-lg-3":"Lsx","mr-lg-3":"Lsz","mx-lg-3":"Ls1","mb-lg-3":"Ls3","ml-lg-3":"Ls5","mt-lg-4":"Ls7","my-lg-4":"Ls9","mr-lg-4":"Ls-","mx-lg-4":"Ltb","mb-lg-4":"Ltd","ml-lg-4":"Ltf","mt-lg-5":"Lth","my-lg-5":"Ltj","mr-lg-5":"Ltl","mx-lg-5":"Ltn","mb-lg-5":"Ltp","ml-lg-5":"Ltr","pt-lg-0":"Ltt","py-lg-0":"Ltv","pr-lg-0":"Ltx","px-lg-0":"Ltz","pb-lg-0":"Lt1","pl-lg-0":"Lt3","pt-lg-1":"Lt5","py-lg-1":"Lt7","pr-lg-1":"Lt9","px-lg-1":"Lt-","pb-lg-1":"Lub","pl-lg-1":"Lud","pt-lg-2":"Luf","py-lg-2":"Luh","pr-lg-2":"Luj","px-lg-2":"Lul","pb-lg-2":"Lun","pl-lg-2":"Lup","pt-lg-3":"Lur","py-lg-3":"Lut","pr-lg-3":"Luv","px-lg-3":"Lux","pb-lg-3":"Luz","pl-lg-3":"Lu1","pt-lg-4":"Lu3","py-lg-4":"Lu5","pr-lg-4":"Lu7","px-lg-4":"Lu9","pb-lg-4":"Lu-","pl-lg-4":"Lvb","pt-lg-5":"Lvd","py-lg-5":"Lvf","pr-lg-5":"Lvh","px-lg-5":"Lvj","pb-lg-5":"Lvl","pl-lg-5":"Lvn","mt-lg-n1":"Lvp","my-lg-n1":"Lvr","mr-lg-n1":"Lvt","mx-lg-n1":"Lvv","mb-lg-n1":"Lvx","ml-lg-n1":"Lvz","mt-lg-n2":"Lv1","my-lg-n2":"Lv3","mr-lg-n2":"Lv5","mx-lg-n2":"Lv7","mb-lg-n2":"Lv9","ml-lg-n2":"Lv-","mt-lg-n3":"Lwb","my-lg-n3":"Lwd","mr-lg-n3":"Lwf","mx-lg-n3":"Lwh","mb-lg-n3":"Lwj","ml-lg-n3":"Lwl","mt-lg-n4":"Lwn","my-lg-n4":"Lwp","mr-lg-n4":"Lwr","mx-lg-n4":"Lwt","mb-lg-n4":"Lwv","ml-lg-n4":"Lwx","mt-lg-n5":"Lwz","my-lg-n5":"Lw1","mr-lg-n5":"Lw3","mx-lg-n5":"Lw5","mb-lg-n5":"Lw7","ml-lg-n5":"Lw9","mt-xl-0":"Lw-","my-xl-0":"Lxb","mr-xl-0":"Lxd","mx-xl-0":"Lxf","mb-xl-0":"Lxh","ml-xl-0":"Lxj","mt-xl-1":"Lxl","my-xl-1":"Lxn","mr-xl-1":"Lxp","mx-xl-1":"Lxr","mb-xl-1":"Lxt","ml-xl-1":"Lxv","mt-xl-2":"Lxx","my-xl-2":"Lxz","mr-xl-2":"Lx1","mx-xl-2":"Lx3","mb-xl-2":"Lx5","ml-xl-2":"Lx7","mt-xl-3":"Lx9","my-xl-3":"Lx-","mr-xl-3":"Lyb","mx-xl-3":"Lyd","mb-xl-3":"Lyf","ml-xl-3":"Lyh","mt-xl-4":"Lyj","my-xl-4":"Lyl","mr-xl-4":"Lyn","mx-xl-4":"Lyp","mb-xl-4":"Lyr","ml-xl-4":"Lyt","mt-xl-5":"Lyv","my-xl-5":"Lyx","mr-xl-5":"Lyz","mx-xl-5":"Ly1","mb-xl-5":"Ly3","ml-xl-5":"Ly5","pt-xl-0":"Ly7","py-xl-0":"Ly9","pr-xl-0":"Ly-","px-xl-0":"Lzb","pb-xl-0":"Lzd","pl-xl-0":"Lzf","pt-xl-1":"Lzh","py-xl-1":"Lzj","pr-xl-1":"Lzl","px-xl-1":"Lzn","pb-xl-1":"Lzp","pl-xl-1":"Lzr","pt-xl-2":"Lzt","py-xl-2":"Lzv","pr-xl-2":"Lzx","px-xl-2":"Lzz","pb-xl-2":"Lz1","pl-xl-2":"Lz3","pt-xl-3":"Lz5","py-xl-3":"Lz7","pr-xl-3":"Lz9","px-xl-3":"Lz-","pb-xl-3":"Laab","pl-xl-3":"Laad","pt-xl-4":"Laaf","py-xl-4":"Laah","pr-xl-4":"Laaj","px-xl-4":"Laal","pb-xl-4":"Laan","pl-xl-4":"Laap","pt-xl-5":"Laar","py-xl-5":"Laat","pr-xl-5":"Laav","px-xl-5":"Laax","pb-xl-5":"Laaz","pl-xl-5":"Laa1","mt-xl-n1":"Laa3","my-xl-n1":"Laa5","mr-xl-n1":"Laa7","mx-xl-n1":"Laa9","mb-xl-n1":"Laa-","ml-xl-n1":"Labb","mt-xl-n2":"Labd","my-xl-n2":"Labf","mr-xl-n2":"Labh","mx-xl-n2":"Labj","mb-xl-n2":"Labl","ml-xl-n2":"Labn","mt-xl-n3":"Labp","my-xl-n3":"Labr","mr-xl-n3":"Labt","mx-xl-n3":"Labv","mb-xl-n3":"Labx","ml-xl-n3":"Labz","mt-xl-n4":"Lab1","my-xl-n4":"Lab3","mr-xl-n4":"Lab5","mx-xl-n4":"Lab7","mb-xl-n4":"Lab9","ml-xl-n4":"Lab-","mt-xl-n5":"Lacb","my-xl-n5":"Lacd","mr-xl-n5":"Lacf","mx-xl-n5":"Lach","mb-xl-n5":"Lacj","ml-xl-n5":"Lacl","horizontal-layout-view":"Ladp","img-container":"Ladr","float":"Ladt","desk-only":"Ladv","mobile-only":"Ladx","content":"Ladz"};

/***/ }),

/***/ 96104:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"Rf","container-fluid":"Rh","row":"Rj","col-xl-9":"Rl","col-xl-3":"Rn","col-md-8":"Rp","col-md-4":"Rr","col-sm-4":"Rt","col-12":"Rv","d-none":"Rx","d-block":"Rz","d-table":"Rab","d-table-row":"Rad","d-table-cell":"Raf","d-flex":"Rah","d-sm-table":"Raj","d-sm-table-row":"Ral","d-sm-table-cell":"Ran","d-md-inline":"Rap","d-md-table":"Rar","d-md-table-row":"Rat","d-md-table-cell":"Rav","d-lg-block":"Rax","d-lg-table":"Raz","d-lg-table-row":"Ra1","d-lg-table-cell":"Ra3","d-lg-flex":"Ra5","d-xl-inline":"Ra7","d-xl-table":"Ra9","d-xl-table-row":"Ra-","d-xl-table-cell":"Rbb","d-print-table":"Rbd","d-print-table-row":"Rbf","d-print-table-cell":"Rbh","flex-column":"Rbj","mt-0":"Rbl","my-0":"Rbn","mr-0":"Rbp","mx-0":"Rbr","mb-0":"Rbt","ml-0":"Rbv","mt-1":"Rbx","my-1":"Rbz","mr-1":"Rb1","mx-1":"Rb3","mb-1":"Rb5","ml-1":"Rb7","mt-2":"Rb9","my-2":"Rb-","mr-2":"Rcb","mx-2":"Rcd","mb-2":"Rcf","ml-2":"Rch","mt-3":"Rcj","my-3":"Rcl","mr-3":"Rcn","mx-3":"Rcp","mb-3":"Rcr","ml-3":"Rct","mt-4":"Rcv","my-4":"Rcx","mr-4":"Rcz","mx-4":"Rc1","mb-4":"Rc3","ml-4":"Rc5","mt-5":"Rc7","my-5":"Rc9","mr-5":"Rc-","mx-5":"Rdb","mb-5":"Rdd","ml-5":"Rdf","p-0":"Rdh","pt-0":"Rdj","py-0":"Rdl","pr-0":"Rdn","px-0":"Rdp","pb-0":"Rdr","pl-0":"Rdt","pt-1":"Rdv","py-1":"Rdx","pr-1":"Rdz","px-1":"Rd1","pb-1":"Rd3","pl-1":"Rd5","pt-2":"Rd7","py-2":"Rd9","pr-2":"Rd-","px-2":"Reb","pb-2":"Red","pl-2":"Ref","p-3":"Reh","pt-3":"Rej","py-3":"Rel","pr-3":"Ren","px-3":"Rep","pb-3":"Rer","pl-3":"Ret","pt-4":"Rev","py-4":"Rex","pr-4":"Rez","px-4":"Re1","pb-4":"Re3","pl-4":"Re5","pt-5":"Re7","py-5":"Re9","pr-5":"Re-","px-5":"Rfb","pb-5":"Rfd","pl-5":"Rff","mt-n1":"Rfh","my-n1":"Rfj","mr-n1":"Rfl","mx-n1":"Rfn","mb-n1":"Rfp","ml-n1":"Rfr","mt-n2":"Rft","my-n2":"Rfv","mr-n2":"Rfx","mx-n2":"Rfz","mb-n2":"Rf1","ml-n2":"Rf3","mt-n3":"Rf5","my-n3":"Rf7","mr-n3":"Rf9","mx-n3":"Rf-","mb-n3":"Rgb","ml-n3":"Rgd","mt-n4":"Rgf","my-n4":"Rgh","mr-n4":"Rgj","mx-n4":"Rgl","mb-n4":"Rgn","ml-n4":"Rgp","mt-n5":"Rgr","my-n5":"Rgt","mr-n5":"Rgv","mx-n5":"Rgx","mb-n5":"Rgz","ml-n5":"Rg1","ml-auto":"Rg3","mt-sm-0":"Rg5","my-sm-0":"Rg7","mr-sm-0":"Rg9","mx-sm-0":"Rg-","mb-sm-0":"Rhb","ml-sm-0":"Rhd","mt-sm-1":"Rhf","my-sm-1":"Rhh","mr-sm-1":"Rhj","mx-sm-1":"Rhl","mb-sm-1":"Rhn","ml-sm-1":"Rhp","mt-sm-2":"Rhr","my-sm-2":"Rht","mr-sm-2":"Rhv","mx-sm-2":"Rhx","mb-sm-2":"Rhz","ml-sm-2":"Rh1","mt-sm-3":"Rh3","my-sm-3":"Rh5","mr-sm-3":"Rh7","mx-sm-3":"Rh9","mb-sm-3":"Rh-","ml-sm-3":"Rib","mt-sm-4":"Rid","my-sm-4":"Rif","mr-sm-4":"Rih","mx-sm-4":"Rij","mb-sm-4":"Ril","ml-sm-4":"Rin","mt-sm-5":"Rip","my-sm-5":"Rir","mr-sm-5":"Rit","mx-sm-5":"Riv","mb-sm-5":"Rix","ml-sm-5":"Riz","pt-sm-0":"Ri1","py-sm-0":"Ri3","pr-sm-0":"Ri5","px-sm-0":"Ri7","pb-sm-0":"Ri9","pl-sm-0":"Ri-","pt-sm-1":"Rjb","py-sm-1":"Rjd","pr-sm-1":"Rjf","px-sm-1":"Rjh","pb-sm-1":"Rjj","pl-sm-1":"Rjl","pt-sm-2":"Rjn","py-sm-2":"Rjp","pr-sm-2":"Rjr","px-sm-2":"Rjt","pb-sm-2":"Rjv","pl-sm-2":"Rjx","pt-sm-3":"Rjz","py-sm-3":"Rj1","pr-sm-3":"Rj3","px-sm-3":"Rj5","pb-sm-3":"Rj7","pl-sm-3":"Rj9","pt-sm-4":"Rj-","py-sm-4":"Rkb","pr-sm-4":"Rkd","px-sm-4":"Rkf","pb-sm-4":"Rkh","pl-sm-4":"Rkj","pt-sm-5":"Rkl","py-sm-5":"Rkn","pr-sm-5":"Rkp","px-sm-5":"Rkr","pb-sm-5":"Rkt","pl-sm-5":"Rkv","mt-sm-n1":"Rkx","my-sm-n1":"Rkz","mr-sm-n1":"Rk1","mx-sm-n1":"Rk3","mb-sm-n1":"Rk5","ml-sm-n1":"Rk7","mt-sm-n2":"Rk9","my-sm-n2":"Rk-","mr-sm-n2":"Rlb","mx-sm-n2":"Rld","mb-sm-n2":"Rlf","ml-sm-n2":"Rlh","mt-sm-n3":"Rlj","my-sm-n3":"Rll","mr-sm-n3":"Rln","mx-sm-n3":"Rlp","mb-sm-n3":"Rlr","ml-sm-n3":"Rlt","mt-sm-n4":"Rlv","my-sm-n4":"Rlx","mr-sm-n4":"Rlz","mx-sm-n4":"Rl1","mb-sm-n4":"Rl3","ml-sm-n4":"Rl5","mt-sm-n5":"Rl7","my-sm-n5":"Rl9","mr-sm-n5":"Rl-","mx-sm-n5":"Rmb","mb-sm-n5":"Rmd","ml-sm-n5":"Rmf","mt-md-0":"Rmh","my-md-0":"Rmj","mr-md-0":"Rml","mx-md-0":"Rmn","mb-md-0":"Rmp","ml-md-0":"Rmr","mt-md-1":"Rmt","my-md-1":"Rmv","mr-md-1":"Rmx","mx-md-1":"Rmz","mb-md-1":"Rm1","ml-md-1":"Rm3","mt-md-2":"Rm5","my-md-2":"Rm7","mr-md-2":"Rm9","mx-md-2":"Rm-","mb-md-2":"Rnb","ml-md-2":"Rnd","mt-md-3":"Rnf","my-md-3":"Rnh","mr-md-3":"Rnj","mx-md-3":"Rnl","mb-md-3":"Rnn","ml-md-3":"Rnp","mt-md-4":"Rnr","my-md-4":"Rnt","mr-md-4":"Rnv","mx-md-4":"Rnx","mb-md-4":"Rnz","ml-md-4":"Rn1","mt-md-5":"Rn3","my-md-5":"Rn5","mr-md-5":"Rn7","mx-md-5":"Rn9","mb-md-5":"Rn-","ml-md-5":"Rob","pt-md-0":"Rod","py-md-0":"Rof","pr-md-0":"Roh","px-md-0":"Roj","pb-md-0":"Rol","pl-md-0":"Ron","pt-md-1":"Rop","py-md-1":"Ror","pr-md-1":"Rot","px-md-1":"Rov","pb-md-1":"Rox","pl-md-1":"Roz","pt-md-2":"Ro1","py-md-2":"Ro3","pr-md-2":"Ro5","px-md-2":"Ro7","pb-md-2":"Ro9","pl-md-2":"Ro-","pt-md-3":"Rpb","py-md-3":"Rpd","pr-md-3":"Rpf","px-md-3":"Rph","pb-md-3":"Rpj","pl-md-3":"Rpl","pt-md-4":"Rpn","py-md-4":"Rpp","pr-md-4":"Rpr","px-md-4":"Rpt","pb-md-4":"Rpv","pl-md-4":"Rpx","pt-md-5":"Rpz","py-md-5":"Rp1","pr-md-5":"Rp3","px-md-5":"Rp5","pb-md-5":"Rp7","pl-md-5":"Rp9","mt-md-n1":"Rp-","my-md-n1":"Rqb","mr-md-n1":"Rqd","mx-md-n1":"Rqf","mb-md-n1":"Rqh","ml-md-n1":"Rqj","mt-md-n2":"Rql","my-md-n2":"Rqn","mr-md-n2":"Rqp","mx-md-n2":"Rqr","mb-md-n2":"Rqt","ml-md-n2":"Rqv","mt-md-n3":"Rqx","my-md-n3":"Rqz","mr-md-n3":"Rq1","mx-md-n3":"Rq3","mb-md-n3":"Rq5","ml-md-n3":"Rq7","mt-md-n4":"Rq9","my-md-n4":"Rq-","mr-md-n4":"Rrb","mx-md-n4":"Rrd","mb-md-n4":"Rrf","ml-md-n4":"Rrh","mt-md-n5":"Rrj","my-md-n5":"Rrl","mr-md-n5":"Rrn","mx-md-n5":"Rrp","mb-md-n5":"Rrr","ml-md-n5":"Rrt","ml-md-auto":"Rrv","mt-lg-0":"Rrx","my-lg-0":"Rrz","mr-lg-0":"Rr1","mx-lg-0":"Rr3","mb-lg-0":"Rr5","ml-lg-0":"Rr7","mt-lg-1":"Rr9","my-lg-1":"Rr-","mr-lg-1":"Rsb","mx-lg-1":"Rsd","mb-lg-1":"Rsf","ml-lg-1":"Rsh","mt-lg-2":"Rsj","my-lg-2":"Rsl","mr-lg-2":"Rsn","mx-lg-2":"Rsp","mb-lg-2":"Rsr","ml-lg-2":"Rst","mt-lg-3":"Rsv","my-lg-3":"Rsx","mr-lg-3":"Rsz","mx-lg-3":"Rs1","mb-lg-3":"Rs3","ml-lg-3":"Rs5","mt-lg-4":"Rs7","my-lg-4":"Rs9","mr-lg-4":"Rs-","mx-lg-4":"Rtb","mb-lg-4":"Rtd","ml-lg-4":"Rtf","mt-lg-5":"Rth","my-lg-5":"Rtj","mr-lg-5":"Rtl","mx-lg-5":"Rtn","mb-lg-5":"Rtp","ml-lg-5":"Rtr","pt-lg-0":"Rtt","py-lg-0":"Rtv","pr-lg-0":"Rtx","px-lg-0":"Rtz","pb-lg-0":"Rt1","pl-lg-0":"Rt3","pt-lg-1":"Rt5","py-lg-1":"Rt7","pr-lg-1":"Rt9","px-lg-1":"Rt-","pb-lg-1":"Rub","pl-lg-1":"Rud","pt-lg-2":"Ruf","py-lg-2":"Ruh","pr-lg-2":"Ruj","px-lg-2":"Rul","pb-lg-2":"Run","pl-lg-2":"Rup","pt-lg-3":"Rur","py-lg-3":"Rut","pr-lg-3":"Ruv","px-lg-3":"Rux","pb-lg-3":"Ruz","pl-lg-3":"Ru1","pt-lg-4":"Ru3","py-lg-4":"Ru5","pr-lg-4":"Ru7","px-lg-4":"Ru9","pb-lg-4":"Ru-","pl-lg-4":"Rvb","pt-lg-5":"Rvd","py-lg-5":"Rvf","pr-lg-5":"Rvh","px-lg-5":"Rvj","pb-lg-5":"Rvl","pl-lg-5":"Rvn","mt-lg-n1":"Rvp","my-lg-n1":"Rvr","mr-lg-n1":"Rvt","mx-lg-n1":"Rvv","mb-lg-n1":"Rvx","ml-lg-n1":"Rvz","mt-lg-n2":"Rv1","my-lg-n2":"Rv3","mr-lg-n2":"Rv5","mx-lg-n2":"Rv7","mb-lg-n2":"Rv9","ml-lg-n2":"Rv-","mt-lg-n3":"Rwb","my-lg-n3":"Rwd","mr-lg-n3":"Rwf","mx-lg-n3":"Rwh","mb-lg-n3":"Rwj","ml-lg-n3":"Rwl","mt-lg-n4":"Rwn","my-lg-n4":"Rwp","mr-lg-n4":"Rwr","mx-lg-n4":"Rwt","mb-lg-n4":"Rwv","ml-lg-n4":"Rwx","mt-lg-n5":"Rwz","my-lg-n5":"Rw1","mr-lg-n5":"Rw3","mx-lg-n5":"Rw5","mb-lg-n5":"Rw7","ml-lg-n5":"Rw9","mt-xl-0":"Rw-","my-xl-0":"Rxb","mr-xl-0":"Rxd","mx-xl-0":"Rxf","mb-xl-0":"Rxh","ml-xl-0":"Rxj","mt-xl-1":"Rxl","my-xl-1":"Rxn","mr-xl-1":"Rxp","mx-xl-1":"Rxr","mb-xl-1":"Rxt","ml-xl-1":"Rxv","mt-xl-2":"Rxx","my-xl-2":"Rxz","mr-xl-2":"Rx1","mx-xl-2":"Rx3","mb-xl-2":"Rx5","ml-xl-2":"Rx7","mt-xl-3":"Rx9","my-xl-3":"Rx-","mr-xl-3":"Ryb","mx-xl-3":"Ryd","mb-xl-3":"Ryf","ml-xl-3":"Ryh","mt-xl-4":"Ryj","my-xl-4":"Ryl","mr-xl-4":"Ryn","mx-xl-4":"Ryp","mb-xl-4":"Ryr","ml-xl-4":"Ryt","mt-xl-5":"Ryv","my-xl-5":"Ryx","mr-xl-5":"Ryz","mx-xl-5":"Ry1","mb-xl-5":"Ry3","ml-xl-5":"Ry5","pt-xl-0":"Ry7","py-xl-0":"Ry9","pr-xl-0":"Ry-","px-xl-0":"Rzb","pb-xl-0":"Rzd","pl-xl-0":"Rzf","pt-xl-1":"Rzh","py-xl-1":"Rzj","pr-xl-1":"Rzl","px-xl-1":"Rzn","pb-xl-1":"Rzp","pl-xl-1":"Rzr","pt-xl-2":"Rzt","py-xl-2":"Rzv","pr-xl-2":"Rzx","px-xl-2":"Rzz","pb-xl-2":"Rz1","pl-xl-2":"Rz3","pt-xl-3":"Rz5","py-xl-3":"Rz7","pr-xl-3":"Rz9","px-xl-3":"Rz-","pb-xl-3":"Raab","pl-xl-3":"Raad","pt-xl-4":"Raaf","py-xl-4":"Raah","pr-xl-4":"Raaj","px-xl-4":"Raal","pb-xl-4":"Raan","pl-xl-4":"Raap","pt-xl-5":"Raar","py-xl-5":"Raat","pr-xl-5":"Raav","px-xl-5":"Raax","pb-xl-5":"Raaz","pl-xl-5":"Raa1","mt-xl-n1":"Raa3","my-xl-n1":"Raa5","mr-xl-n1":"Raa7","mx-xl-n1":"Raa9","mb-xl-n1":"Raa-","ml-xl-n1":"Rabb","mt-xl-n2":"Rabd","my-xl-n2":"Rabf","mr-xl-n2":"Rabh","mx-xl-n2":"Rabj","mb-xl-n2":"Rabl","ml-xl-n2":"Rabn","mt-xl-n3":"Rabp","my-xl-n3":"Rabr","mr-xl-n3":"Rabt","mx-xl-n3":"Rabv","mb-xl-n3":"Rabx","ml-xl-n3":"Rabz","mt-xl-n4":"Rab1","my-xl-n4":"Rab3","mr-xl-n4":"Rab5","mx-xl-n4":"Rab7","mb-xl-n4":"Rab9","ml-xl-n4":"Rab-","mt-xl-n5":"Racb","my-xl-n5":"Racd","mr-xl-n5":"Racf","mx-xl-n5":"Rach","mb-xl-n5":"Racj","ml-xl-n5":"Racl","cms-abstract":"Rad5"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [598,719,675,345,916,774,888,179], function() { return __webpack_exec__(36994); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);